const intFmt = new Intl.NumberFormat("en-US");
const compactFmt = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 });

export const fmtInt = (n: number | null | undefined) => (n === null || n === undefined ? "—" : intFmt.format(n));
export const fmtCompact = (n: number | null | undefined) => (n === null || n === undefined ? "—" : compactFmt.format(n));
export const fmtPct = (r: number | null | undefined, digits = 0) =>
  r === null || r === undefined ? "—" : `${(r * 100).toFixed(digits)}%`;

/** 41200 → "41.2s", 125000 → "2:05". */
export function fmtMs(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return "—";
  if (ms < 60_000) return `${(ms / 1000).toFixed(1)}s`;
  const s = Math.round(ms / 1000);
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}

export const shortId = (id: string, n = 8) => (id.length > n + 1 ? `${id.slice(0, n)}…` : id);

/** `pattern.matrix` → "matrix" */
export const typeSlug = (type: string | null | undefined) => (type ? (type.split(".")[1] ?? type).replace(/_/g, " ") : "—");

// ---------------------------------------------------------------- answers (launch kinds: contracts/README.md "Answers")

type AnswerLike = { kind: string; value: unknown };
const COLUMNS = "ABCDEFGHIJKL";
/** `[1, 0]` → `A2`: column letter, 1-based row (the board's coordinate labels). */
export const cellName = ([r, c]: readonly [number, number]) => `${COLUMNS[c] ?? String(c + 1)}${r + 1}`;

/**
 * An answer as a reviewer reads it. choice → the option id; cellSet → `r,c;r,c` (sorted); number → the number;
 * digits → the digits; fill → the values in blank order; sequence → an ordered list (`1 B2 → 2 A1`); rows → Yes/No per row.
 */
export function formatAnswer(answer: AnswerLike): string {
  const v = answer.value;
  switch (answer.kind) {
    case "choice":
    case "number":
    case "digits":
      return String(v);
    case "cellSet": // unchanged: the canonical `r,c;r,c` (sorted)
      return [...(v as [number, number][])].sort((a, b) => a[0] - b[0] || a[1] - b[1]).map(([r, c]) => `${r},${c}`).join(";");
    case "fill":
      return (v as unknown[]).map(String).join(", ");
    case "sequence":
      return (v as [number, number][]).map((cell, i) => `${i + 1} ${cellName(cell)}`).join(" → ");
    case "rows":
      return [...String(v)].map((ch) => (ch === "Y" ? "Yes" : "No")).join(" · ");
    default:
      return JSON.stringify(v);
  }
}
